var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaTradeS4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 186,
    height: 186,
    transform: "translate(5066 -3103)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_188",
    "data-name": "Mask Group 188",
    transform: "translate(-5066 3103)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6b0e28_1_",
    "data-name": "c6b0e28 (1)",
    transform: "translate(5104 -3065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60993",
    "data-name": "Path 60993",
    d: "M64.594,110.968H18.455C6.459,110.968,0,100.23,0,90.184a2.315,2.315,0,0,1,2.307-2.309H43.832a2.315,2.315,0,0,1,2.307,2.309c0,7.852,9.458,16.165,18.455,16.165a2.309,2.309,0,0,1,0,4.619ZM4.729,92.494c.923,7.043,5.652,13.856,13.726,13.856H50.983c-4.845-3.464-8.42-8.544-9.228-13.856Z",
    transform: "translate(0 -0.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60994",
    "data-name": "Path 60994",
    d: "M108.588,23.093H87.711a2.309,2.309,0,0,1,0-4.619h18.34c-.808-7.043-5.536-13.856-13.611-13.856H36.958a2.309,2.309,0,0,1,0-4.619H92.44c12,0,18.455,10.738,18.455,20.784A2.315,2.315,0,0,1,108.588,23.093Z",
    transform: "translate(-0.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60995",
    "data-name": "Path 60995",
    d: "M64.679,110.851a2.309,2.309,0,0,1,0-4.619c9,0,18.455-8.314,18.455-16.165V4.622a2.307,2.307,0,1,1,4.614,0V90.067C87.748,100.574,76.329,110.851,64.679,110.851Z",
    transform: "translate(-0.086 -0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60996",
    "data-name": "Path 60996",
    d: "M25.408,90.08A2.315,2.315,0,0,1,23.1,87.77v-73.9a2.307,2.307,0,1,1,4.614,0v73.9A2.315,2.315,0,0,1,25.408,90.08Z",
    transform: "translate(-0.032 -0.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60997",
    "data-name": "Path 60997",
    d: "M25.408,16.165A2.315,2.315,0,0,1,23.1,13.856,13.889,13.889,0,0,1,36.942,0a2.309,2.309,0,0,1,0,4.619,9.26,9.26,0,0,0-9.228,9.237A2.315,2.315,0,0,1,25.408,16.165Z",
    transform: "translate(-0.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60998",
    "data-name": "Path 60998",
    d: "M42.968,25.19,53.81,33.619,70.42,13.3",
    transform: "translate(-0.059 -0.018)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x2: 35.56,
    transform: "translate(38.126 51.516)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 35.56,
    transform: "translate(38.126 61.155)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 35.56,
    transform: "translate(38.126 70.794)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaTradeS4);
export default __webpack_public_path__ + "static/media/avaTrade-s4.b5cf214f68eeed6b56145b459758c1b0.svg";
export { ForwardRef as ReactComponent };